export default "__VITE_ASSET__1sZlI$_W__"